import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

const navConfig = [
  {
    label: "About Us",
    items: [
      { label: "Company", path: "/about/company" },
      { label: "Team", path: "/about/team" },
    ],
  },
  {
    label: "For Nonprofits",
    path: "/",
    dropdown: true,
    items: [
      { label: "Mission Hub", path: "/solutions/mission-hub" },
      { label: "AI Assistant", path: "/solutions/ai-assistant" },
      { label: "AI Growth Engine", path: "/solutions/ai-growth-engine" },
    ],
  },
  {
    label: "For Corporates",
    path: "/corporate",
    dropdown: false,
    items: [],
  },
  {
    label: "Resources",
    items: [
      { label: "Guides", path: "/guides" },
      {
        label: "Budget & Impact Calculator",
        path: "/resources/budget-calculator",
      },
      { label: "UN Campaign Planner", path: "/resources/un-campaign-planner" },
      {
        label: "Carbon Offset Estimator",
        path: "/resources/CarbonOffsetEstimatorPage",
      },
    ],
  },
];

export const DesktopNav = ({
  profile,
  session,
}: {
  profile: any;
  session: any;
}) => {
  const [openNonprofit, setOpenNonprofit] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="hidden md:flex space-x-6 items-center justify-center flex-1">
      {navConfig.map((nav) => {
        // For Nonprofits: label navigates to index and opens dropdown
        if (nav.label === "For Nonprofits") {
          return (
            <DropdownMenu
              key={nav.label}
              open={openNonprofit}
              onOpenChange={setOpenNonprofit}
            >
              <div
                onMouseEnter={() => setOpenNonprofit(true)}
                onMouseLeave={() => setOpenNonprofit(false)}
                style={{ display: "inline-block" }}
              >
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="ghost"
                    className="text-gray-600 hover:text-primary hover:bg-transparent"
                    aria-haspopup="menu"
                    aria-expanded={openNonprofit}
                    onClick={() => {
                      navigate(nav.path!);
                      setOpenNonprofit(true);
                    }}
                  >
                    {nav.label} <ChevronDown className="ml-1 h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" className="w-64">
                  {nav.items?.map((item) => (
                    <DropdownMenuItem
                      key={item.label}
                      onClick={() => navigate(item.path)}
                    >
                      {item.label}
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </div>
            </DropdownMenu>
          );
        }
        // For Corporates: direct link, no dropdown
        if (nav.label === "For Corporates") {
          const isActive = location.pathname === nav.path;
          return (
            <Button
              key={nav.label}
              variant="ghost"
              className={cn(
                "text-gray-600 hover:text-primary hover:bg-transparent",
                isActive ? "bg-gray-100" : ""
              )}
              onClick={() => navigate(nav.path!)}
              style={{ fontWeight: 400 }}
            >
              {nav.label}
            </Button>
          );
        }
        // Dropdown for About Us, Resources, etc.
        if (nav.items && nav.items.length > 0) {
          return (
            <DropdownMenu key={nav.label}>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  className="text-gray-600 hover:text-primary hover:bg-transparent"
                >
                  {nav.label} <ChevronDown className="ml-1 h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-48">
                {nav.items.map((item) => (
                  <DropdownMenuItem
                    key={item.label}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          );
        }
        return null;
      })}
    </div>
  );
};
